import { useSelector } from 'react-redux';
import FJModal from '../FJModal';
import FJGlobalLoading from './FJGlobalLoading';

const FJGlobalLoadingContainer = () => {
    const globalLoadingDisplay = useSelector(state => state.modals.globalLoadingDisplay);
    return (
        <FJModal visible={globalLoadingDisplay} maskStyle={{ background: 'rgb(0 0 0 / 78%)' }}>
            <FJGlobalLoading />
        </FJModal>
    );
};
export default FJGlobalLoadingContainer;
